import axios from 'axios';
import history from '../../history';
import Config from '../../config';
import store from '../../store';
import { reset } from '../dataSet/actions';
import {PREFIX_URL} from "../../constants";
import { mockIndustries, mockOfferings, mockSubOfferings, mockProcesses, mockRegions } from '../mockData';

const { backendUrl } = Config.network;

axios.defaults.withCredentials = false;

export function incrementStatistic(type, pk) {
  const { branchPk } = store.getState().common;
  const url = `${backendUrl}/api/production/${type}/${pk}/increase_counter`;
  axios.get(
    url, {
      headers: {
        'Cache-Control': 'no-cache',
        'Access-Control-Allow-Origin' : 'localhost:1880'
      },
      params: {
        branch_pk: branchPk
      }
    }
  );
}

export function resetAll() {
  return function action(dispatch) {
    setTimeout(function () {
      localStorage.setItem('industries', JSON.stringify(null));
      localStorage.setItem('offerings', JSON.stringify(null));
      localStorage.setItem('subOfferings', JSON.stringify(null));
      localStorage.setItem('processes', JSON.stringify(null));
      localStorage.setItem('regions', JSON.stringify(null));

      localStorage.setItem('process', JSON.stringify(null));
      localStorage.setItem('processId', JSON.stringify(null));
      localStorage.setItem('regionId', JSON.stringify(null));
      localStorage.setItem('industryId', JSON.stringify(null));

      localStorage.setItem('activeIndustry', JSON.stringify(null));
      localStorage.setItem('activeOffering', JSON.stringify(null));
      localStorage.setItem('activeSubOffering', JSON.stringify(null));
      localStorage.setItem('activeProcess', JSON.stringify(null));
      localStorage.setItem('activeRegion', JSON.stringify(null));

      localStorage.setItem('industrySelected', JSON.stringify(null));
      localStorage.setItem('offeringSelected', JSON.stringify(null));
      localStorage.setItem('subOfferingSelected', JSON.stringify(null));
      localStorage.setItem('processSelected', JSON.stringify(null));
      localStorage.setItem('regionSelected', JSON.stringify(null));
    }, 100);
    const newPath = PREFIX_URL;
    history.push(newPath);
    dispatch({
      type: 'RESET_FILTERS',
    });
    dispatch(reset());
  };
}

export function getIndustries() {
  return function action(dispatch) {
    dispatch({
      type: 'МАКЕ_REQUEST',
    });
    const { branchPk } = store.getState().common;
    const url = `${backendUrl}/api/production/industries`;
    axios.get(
      url, {
        headers: {
          'Cache-Control': 'no-cache'
        },
        params: {
          branch_pk: branchPk
        }
      }
    ).then((body) => {
      const { data } = body;
      setTimeout(function () {
        localStorage.setItem('industries', JSON.stringify(data));
      }, 100);
      dispatch({
        type: 'GET_INDUSTRIES',
        payload: {
          industries: data,
        },
      });
      dispatch({
        type: 'REQUEST_SUCCESSFUL',
      });
    }).catch(error => {
      console.warn('[PMM] Industries endpoint unreachable, using mock data:', error.message);
      dispatch({ type: 'SET_OFFLINE_MODE', payload: { offlineMode: true } });
      dispatch({
        type: 'GET_INDUSTRIES',
        payload: { industries: mockIndustries },
      });
      dispatch({ type: 'REQUEST_SUCCESSFUL' });
    });
  };
}

export function getOfferings() {
  return function action(dispatch) {
    dispatch({
      type: 'МАКЕ_REQUEST',
    });
    const { branchPk } = store.getState().common;
    const url = `${backendUrl}/api/production/offerings`;
    axios.get(
      url, {
        headers: {
          'Cache-Control': 'no-cache'
        },
        params: {
          branch_pk: branchPk
        }
      }
    ).then((body) => {
      const { data } = body;
      setTimeout(function () {
        localStorage.setItem('offerings', JSON.stringify(data));
      }, 100);
      dispatch({
        type: 'GET_OFFERINGS',
        payload: {
          offerings: data,
        },
      });
      dispatch({
        type: 'REQUEST_SUCCESSFUL',
      });
    }).catch(error => {
      console.warn('[PMM] Offerings endpoint unreachable, using mock data:', error.message);
      dispatch({ type: 'SET_OFFLINE_MODE', payload: { offlineMode: true } });
      dispatch({
        type: 'GET_OFFERINGS',
        payload: { offerings: mockOfferings },
      });
      dispatch({ type: 'REQUEST_SUCCESSFUL' });
    });
  };
}

export function getSubOfferings(id) {
  return function action(dispatch) {
    dispatch({
      type: 'МАКЕ_REQUEST',
    });
    const { branchPk } = store.getState().common;
    const url = `${backendUrl}/api/production/sub-offerings`;
    axios.get(
      url, {
        params: {
          offering: id,
          branch_pk: branchPk,
        },
        headers: {
          'Cache-Control': 'no-cache'
        },
      },
    ).then((body) => {
      incrementStatistic('offerings', id);
      const { data } = body;
      setTimeout(function () {
        localStorage.setItem('subOfferings', JSON.stringify(data));
      }, 100);
      dispatch({
        type: 'GET_SUB_OFFERINGS',
        payload: {
          subOfferings: data,
        },
      });
      dispatch({
        type: 'REQUEST_SUCCESSFUL',
      });
    }).catch(error => {
      console.warn('[PMM] Sub-offerings endpoint unreachable, using mock data:', error.message);
      dispatch({ type: 'SET_OFFLINE_MODE', payload: { offlineMode: true } });
      dispatch({
        type: 'GET_SUB_OFFERINGS',
        payload: { subOfferings: mockSubOfferings },
      });
      dispatch({ type: 'REQUEST_SUCCESSFUL' });
    });
  };
}

export function getProcesses(id) {
  return function action(dispatch) {
    const url = `${backendUrl}/api/production/processes`;
    dispatch({
      type: 'МАКЕ_REQUEST',
    });
    const { branchPk } = store.getState().common;
    axios.get(
      url, {
        params: {
          'sub-offering': id,
          branch_pk: branchPk
        },
        headers: {
          'Cache-Control': 'no-cache'
        },
      },
    ).then((body) => {
      incrementStatistic('sub-offerings', id);
      const { data } = body;
      setTimeout(function () {
        localStorage.setItem('processes', JSON.stringify(data));
      }, 100);
      dispatch({
        type: 'GET_PROCESSES',
        payload: {
          processes: data,
        },
      });
      dispatch({
        type: 'REQUEST_SUCCESSFUL',
      });
    }).catch(error => {
      console.warn('[PMM] Processes endpoint unreachable, using mock data:', error.message);
      dispatch({ type: 'SET_OFFLINE_MODE', payload: { offlineMode: true } });
      dispatch({
        type: 'GET_PROCESSES',
        payload: { processes: mockProcesses },
      });
      dispatch({ type: 'REQUEST_SUCCESSFUL' });
    });
  };
}

export function getRegions() {
  return function action(dispatch) {
    dispatch({
      type: 'МАКЕ_REQUEST',
    });
    const { branchPk } = store.getState().common;
    const url = `${backendUrl}/api/production/regions`;
    const { processId } = store.getState().filter;
    axios.get(
      url, {
        params: {
          'process': processId,
          branch_pk: branchPk
        },
        headers: {
          'Cache-Control': 'no-cache'
        },
      }
    ).then((body) => {
      const { data } = body;
      setTimeout(function () {
        localStorage.setItem('regions', JSON.stringify(data));
      }, 100);
      dispatch({
        type: 'GET_REGIONS',
        payload: {
          regions: data,
        },
      });
      dispatch({
        type: 'REQUEST_SUCCESSFUL',
      });
    }).catch(error => {
      console.warn('[PMM] Regions endpoint unreachable, using mock data:', error.message);
      dispatch({ type: 'SET_OFFLINE_MODE', payload: { offlineMode: true } });
      dispatch({
        type: 'GET_REGIONS',
        payload: { regions: mockRegions },
      });
      dispatch({ type: 'REQUEST_SUCCESSFUL' });
    });
  };
}

export function setProcess(id) {
  return function action(dispatch) {
    incrementStatistic('processes', id);
    setTimeout(function () {
      localStorage.setItem('processId', JSON.stringify(id));
    }, 100);
    dispatch({
      type: 'SET_PROCESS',
      payload: {
        processId: id,
      },
    });
  };
}


export function setRegion(id) {
  return function action(dispatch) {
    setTimeout(function () {
      localStorage.setItem('regionId', JSON.stringify(id));
    }, 100);
    dispatch({
      type: 'SET_REGION_ID',
      payload: {
        regionId: id,
      },
    });
  };
}

export function setIndustry(id) {
  return function action(dispatch) {
    setTimeout(function () {
      localStorage.setItem('industryId', JSON.stringify(id));
    }, 100);
    dispatch({
      type: 'SET_INDUSTRY_ID',
      payload: {
        industryId: id,
      },
    });
  };
}


export function setActiveFilterName(type, name) {
  return function action(dispatch) {
    switch (type) {
    case 'industry':
      setTimeout(function () {
        localStorage.setItem('activeIndustry', JSON.stringify(name));
      }, 100);
      dispatch({
        type: 'SET_INDUSTRY_NAME',
        payload: {
          activeIndustry: name,
        },
      });
      break;
    case 'offering':
      setTimeout(function () {
        localStorage.setItem('activeOffering', JSON.stringify(name));
      }, 100);
      dispatch({
        type: 'SET_OFFERING_NAME',
        payload: {
          activeOffering: name,
        },
      });
      break;
    case 'subOffering':
      setTimeout(function () {
        localStorage.setItem('activeSubOffering', JSON.stringify(name));
      }, 100);
      dispatch({
        type: 'SET_SUB_OFFERING_NAME',
        payload: {
          activeSubOffering: name,
        },
      });
      break;
    case 'process':
      setTimeout(function () {
        localStorage.setItem('activeProcess', JSON.stringify(name));
      }, 100);
      dispatch({
        type: 'SET_PROCESS_NAME',
        payload: {
          activeProcess: name,
        },
      });
      break;
    case 'region':
      setTimeout(function () {
        localStorage.setItem('activeRegion', JSON.stringify(name));
      }, 100);
      dispatch({
        type: 'SET_REGION_NAME',
        payload: {
          activeRegion: name,
        },
      });
      break;
    default:
      break;
    }
  };
}

export function setSelectedFilterName(context) {
  return function action(dispatch) {
    const { type, name } = context;
    switch (type) {
    case 'industry':
      setTimeout(function () {
        localStorage.setItem('industrySelected', JSON.stringify(name));
      }, 100);
      dispatch({
        type: 'SET_INDUSTRY_SELECTED',
        payload: {
          industrySelected: name,
        },
      });
      break;
    case 'offering':
      setTimeout(function () {
        localStorage.setItem('offeringSelected', JSON.stringify(name));
      }, 100);
      dispatch({
        type: 'SET_OFFERING_SELECTED',
        payload: {
          offeringSelected: name,
        },
      });
      break;
    case 'subOffering':
      setTimeout(function () {
        localStorage.setItem('subOfferingSelected', JSON.stringify(name));
      }, 100);
      dispatch({
        type: 'SET_SUB_OFFERING_SELECTED',
        payload: {
          subOfferingSelected: name,
        },
      });
      break;
    case 'process':
      setTimeout(function () {
        localStorage.setItem('processSelected', JSON.stringify(name));
      }, 100);
      dispatch({
        type: 'SET_PROCESS_SELECTED',
        payload: {
          processSelected: name,
        },
      });
      break;
    case 'region':
      setTimeout(function () {
        localStorage.setItem('regionSelected', JSON.stringify(name));
      }, 100);
      dispatch({
        type: 'SET_REGION_SELECTED',
        payload: {
          regionSelected: name,
        },
      });
      break;
    default:
      break;
    }
  };
}
